module.exports = __webpack_public_path__ + "img/kdgc.70097638.jpg";